import http from '@/http';
import router from '@/router';

export default {
  namespaced: true,
  state: {
    accessToken: null,
    user: {},
  },
  mutations: {
    TOKEN_UPDATE(state, { accessToken, user }) {
      state.accessToken = accessToken;
      state.user = user;
      localStorage.setItem('store', JSON.stringify(state));
    },
  },
  actions: {
    async login(context, form) {
      const response = await http.post(`printer/authorize?username=${form.username}&password=${form.password}`);

      const accessToken = response.data.token;
      const user = response.data.username;

      context.commit('TOKEN_UPDATE', {
        accessToken,
        user,
      });

      return response;
    },
    async logout(context) {
      context.commit('TOKEN_UPDATE', {
        accessToken: null,
      });
      localStorage.removeItem('store');
      if (router.currentRoute.name !== 'login') {
        router.push({
          name: 'login',
        });
      }
    },
    async customer401() {
      if (router.currentRoute.name !== '403') {
        router.push({
          name: 'customer403',
        });
      }
    },
    async customer403() {
      if (router.currentRoute.name !== '403') {
        router.push({
          name: 'customer403',
        });
      }
    },
  },
};
